export const pushNotification = (message) => {
  if (window.Notification && Notification.permission === 'granted') {
    let n = new Notification(message, { tag: 'orderConfirmation' });
  }
};
